import {
  EuiModal,
  EuiModalHeader,
  EuiModalHeaderTitle,
} from "@inscopix/ideas-eui";
import { ProjectFieldsFragment, Tenant } from "../../graphql/_Types";
import {
  ProjectForm,
  ProjectFormMode,
} from "components/ProjectForm/ProjectForm";

export interface ModalProjectProps {
  onClose: () => void;
  mode: ProjectFormMode;
  project?: Pick<
    ProjectFieldsFragment,
    | "id"
    | "key"
    | "name"
    | "shortDescription"
    | "iconColor"
    | "userId"
    | "tenantId"
  >;
  tenantId?: Tenant["id"];
}

/**
 * Displays a modal to create, edit, or clone a project
 */
export function ModalProject({
  onClose,
  mode,
  project,
  tenantId,
}: ModalProjectProps) {
  const modalTitle = (mode: ProjectFormMode) => {
    switch (mode) {
      case ProjectFormMode.CREATE:
        return "Create Project";
      case ProjectFormMode.EDIT:
        return "Edit Project";
      case ProjectFormMode.CLONE:
        return "Copy Project";
    }
  };

  return (
    <EuiModal onClose={onClose} initialFocus="[name=name]">
      <EuiModalHeader>
        <EuiModalHeaderTitle>{modalTitle(mode)}</EuiModalHeaderTitle>
      </EuiModalHeader>

      <ProjectForm
        onClose={onClose}
        mode={mode}
        project={project}
        tenantId={tenantId}
      />
    </EuiModal>
  );
}
